import React from 'react';

import { Environment } from '../../api/types';

import styles from './BrandLogo.module.scss';

export interface BrandLogoProps {
    id: string;
    vendorAssetsURL: string;
    deployStage: Environment;
    bundle: string;
    brand: string;
    specialLogo?: boolean;
    alt: string | undefined;
}

const BrandLogo: React.FC<BrandLogoProps> = ({
    id,
    vendorAssetsURL,
    deployStage,
    bundle,
    brand,
    specialLogo = false,
    alt,
}) => {
    const logoName = specialLogo ? `${brand}_special` : brand;
    const logoBaseUrl = `${vendorAssetsURL}/media/shop-header/images/${deployStage}/${bundle}/logo/${logoName}`;

    return (
        <a className={styles.logoWrapper} href="/">
            <img
                className={styles.logoImg}
                data-zta="brand_logo"
                id={id}
                src={`${logoBaseUrl}.png`}
                srcSet={`${logoBaseUrl}.png 1x, ${logoBaseUrl}@2x.png 2x`}
                alt={alt}
            />
        </a>
    );
};

export default BrandLogo;
